/**
 * GENERATED FILE - DO NOT EDIT DIRECTLY.
 * Regenerate with: npm run functions:regions
 */

export const OPS_CALLABLE_REGION = 'asia-south2'

export const OPS_CALLABLE_HANDLERS: ReadonlySet<string> = new Set([
  'acceptConMeasurement',
  'acknowledgeOnCall',
  'acknowledgeRequest',
  'acknowledgeRoster',
  'addCapaItems',
  'addConTestResult',
  'addCorrection',
  'addDiaryEntry',
  'addGang',
  'addHospitalComplianceStarters',
  'applyOpsPhoneRecommendedSet',
  'approveDpr',
  'approveRecord',
  'approveTemplateVersion',
  'archiveBookable',
  'archiveBookingPlan',
  'archiveComplianceItem',
  'archiveCoverageRule',
  'archiveCustomer',
  'archiveDepartment',
  'archiveDutyRole',
  'archiveNarcItem',
  'archivePlace',
  'archiveSchedule',
  'archiveShift',
  'archiveWorker',
  'assignRelief',
  'assignRequest',
  'assignRooms',
  'attachBmwPickupReceipt',
  'attachColdBoxPhoto',
  'attachComplianceEvidence',
  'attachConIssuePhotos',
  'attachRequestPhotos',
  'backfillOpsPlaceReadAccess',
  'bookInHouseExtra',
  'bookSession',
  'bookingCheckInByPlaceQr',
  'bulkCreatePlaces',
  'callNextToken',
  'cancelBooking',
  'cancelConMeasurement',
  'cancelLegalHoldLift',
  'cancelLostFoundClaim',
  'cancelMembership',
  'cancelRequest',
  'cancelRosterChange',
  'checkInByCustomerQr',
  'checkInByPhoneOtp',
  'checkInByPlaceQr',
  'checkInHosVisit',
  'checkOutHosVisit',
  'checkOutRoom',
  'clearBookingBlock',
  'closeConIssue',
  'coSignRecord',
  'commentApproval',
  'completeCapaItem',
  'completeLostFoundReturn',
  'confirmBmwHandover',
  'confirmGuestExtraRequest',
  'confirmIvfWitnessStep',
  'confirmLegalHoldLift',
  'confirmSampleHandover',
  'correctBmwDay',
  'correctConMeasurement',
  'createAsset',
  'createBookable',
  'createBookingPlan',
  'createComplianceItem',
  'createConDrawing',
  'createConIssue',
  'createConProject',
  'createConTest',
  'createCoverageRule',
  'createDepartment',
  'createDeviceEnrolCode',
  'createDutyRole',
  'createEngagement',
  'createHomeCollectionJob',
  'createHosPatient',
  'createIvfWitnessStep',
  'createJobOrder',
  'createJobSite',
  'createNarcItem',
  'createOutsideApproval',
  'createParty',
  'createPlace',
  'createPlaceToken',
  'createRoster',
  'createSampleBag',
  'createSchedule',
  'createShift',
  'createStaysPmsConnection',
  'createTeleOrder',
  'createTeleSession',
  'createWorker',
  'decideApproval',
  'decideAttendanceCorrection',
  'decideConIssue',
  'decidePeerProxyMark',
  'decideRosterChange',
  'declineGuestExtraRequest',
  'deleteStaysPmsConnection',
  'describeLostClaim',
  'disputeConMeasurement',
  'endAllocation',
  'enrolSharedDevice',
  'ensureClinicsStarterSet',
  'exportDeliveryCsv',
  'exportNarcRegister',
  'exportOpsCsv',
  'exportOpsWageSheetCsv',
  'finalizeSharedDeviceUpload',
  'findCustomerByPhone',
  'freezeMembership',
  'getApprovalLinkInfo',
  'getBmwHandoverInfo',
  'getBmwStatus',
  'getBmwSummary',
  'getConIssue',
  'getConIssuePhotoUrls',
  'getConMeasureTotals',
  'getConMeasurement',
  'getConPourCard',
  'getConProject',
  'getConReport',
  'getConStarterStatus',
  'getDpr',
  'getEvidenceExportDownload',
  'getFormFPrecheck',
  'getGuestRequestStatus',
  'getGuestRoomForm',
  'getHomeCollectionAddress',
  'getHosPatient',
  'getHosPatientSettings',
  'getHosStarterStatus',
  'getHubSpokeScores',
  'getIncident',
  'getIncidentSettings',
  'getLostClaimLinkInfo',
  'getLostFoundClaimant',
  'getMyBookingQr',
  'getMyOpsPhoneItems',
  'getMyStaffStatus',
  'getOnCallBoard',
  'getOpsWageSheetStatus',
  'getOwnerFeed',
  'getOwnerFeedLinkInfo',
  'getPlaceScanContext',
  'getPlantDowntimeReport',
  'getPlantStarterStatus',
  'getPublicBookingInfo',
  'getQueueBoard',
  'getRxPhotoUrl',
  'getSampleBag',
  'getSampleHandoverInfo',
  'getSampleSettings',
  'getStaysGroupView',
  'getStaysHousekeepingReport',
  'getStaysPmsStatus',
  'getStaysStarterStatus',
  'getTeleSessionPublicInfo',
  'grantMembership',
  'guestStillAProblem',
  'holdQueueToken',
  'importAttendanceCsv',
  'importOpsCsv',
  'importStaysPmsReport',
  'importTempLog',
  'inspectRoom',
  'isolateAsset',
  'issueConDrawingRevision',
  'issueQueueToken',
  'issueSharedDeviceUploadUrl',
  'leaveWaitlist',
  'linkGoalToEngagement',
  'linkMyCustomerRecord',
  'listBedEvents',
  'listChurnCalls',
  'listConDrawingRevisions',
  'listConDrawings',
  'listConIssueDecisions',
  'listConIssues',
  'listConMeasurements',
  'listConParties',
  'listConPourCards',
  'listConProjects',
  'listConTests',
  'listCustomerContacts',
  'listDialyzers',
  'listDiaryEntries',
  'listDisputedConMeasurements',
  'listDprs',
  'listHosPatients',
  'listIncidents',
  'listIvfWitnessQueue',
  'listJobBoard',
  'listJobOrders',
  'listMyOnCallSlots',
  'listMyPublicBookings',
  'listNarcCounts',
  'listNarcItems',
  'listNarcMoves',
  'listOwnerDigests',
  'listQueueTokens',
  'listRenewalsDue',
  'listRequestKinds',
  'listSampleBags',
  'listSharedDevicePeople',
  'listSharedDeviceSessions',
  'listSharedDevices',
  'listStaffStatus',
  'listTeleSessions',
  'lockOpsWageSheet',
  'logFoundItem',
  'manualCheckIn',
  'markAttendanceRoll',
  'markRequestDone',
  'markRoomCleaned',
  'markRoomOccupied',
  'markTokenServed',
  'moveBooking',
  'moveFoundItemBin',
  'movePlace',
  'openApproval',
  'openLostClaim',
  'openOwnerFeed',
  'pauseRoomClean',
  'pauseSchedule',
  'prepareApprovalOtp',
  'prepareBmwHandoverOtp',
  'prepareBookingCheckInOtp',
  'prepareLostClaimOtp',
  'prepareOwnerFeedOtp',
  'prepareRoomCleanRecord',
  'prepareSampleHandoverOtp',
  'prepareTeleConsentOtp',
  'previewOpsWageSheet',
  'previewRosterWarnings',
  'proposeLostFoundDisposal',
  'proxyCoSignRecord',
  'proxyMarkByColleague',
  'publicBookSession',
  'publicCancelBooking',
  'publishRoster',
  'pushStaysGroupTemplate',
  'raiseGuestRequest',
  'raiseRequest',
  'raiseRevisit',
  'reassignConInspector',
  'reassignRoom',
  'receiveSamplesAtLab',
  'recomputeEngagementMargin',
  'recordAssetServiceVisit',
  'recordBmwPickup',
  'recordCheckpointScan',
  'recordConInspectionOutcome',
  'recordCustomerCall',
  'recordDialyzerUse',
  'recordDuePaid',
  'recordEffectiveness',
  'recordFoundItemPhoto',
  'recordHosConsent',
  'recordNarcMove',
  'recordOpsRestrictedView',
  'recordRunnerPing',
  'registerDialyzer',
  'reissueApproverLink',
  'reissueLostFoundClaimLink',
  'reissueOwnerFeedLink',
  'releaseAsset',
  'removeFeedOwner',
  'renameDepartment',
  'renamePlace',
  'renewComplianceItem',
  'renewMembership',
  'reopenRequest',
  'repairOpsPlaceReadAccess',
  'reportIncident',
  'requestAttendanceCorrection',
  'requestConInspection',
  'requestEvidenceExport',
  'requestLegalHoldLift',
  'requestRosterChange',
  'resetSharedDevicePin',
  'resolvePlaceToken',
  'respondConIssue',
  'respondRosterChange',
  'restoreFromRetentionBin',
  'resumeRoomClean',
  'resumeSchedule',
  'retireAsset',
  'retryStaysPmsOutbox',
  'returnDpr',
  'returnRecord',
  'reviewDpr',
  'reviewIncident',
  'reviewRecord',
  'revokeOutsideApproval',
  'revokePlaceToken',
  'revokeSharedDevice',
  'rotateStaysPmsSecret',
  'saveBmwDay',
  'saveConMeasurement',
  'saveConPourCard',
  'saveDprDraft',
  'saveDraftAssignments',
  'saveTemplateDraft',
  'scheduleJob',
  'sendConIssueForApproval',
  'sendOwnerDigestNow',
  'setApprovalSettings',
  'setAssetStatus',
  'setBedState',
  'setBmwSettings',
  'setConProjectApprovers',
  'setConProjectPackages',
  'setEngagementFinance',
  'setEngagementMilestones',
  'setEngagementStatus',
  'setHosPatientDirectoryEnabled',
  'setHosPatientLegalSetup',
  'setHosPatientNotice',
  'setIncidentSettings',
  'setLegalHold',
  'setLostFoundSettings',
  'setMySharedDevicePin',
  'setOpsPhonePersonAccess',
  'setOpsPhoneRoleAccess',
  'setOpsPrivacySettings',
  'setOpsWageRate',
  'setOwnerFeed',
  'setPartyMembers',
  'setPlaceAccess',
  'setPlaceDutyChain',
  'setPlacePreset',
  'setPlantNearMissExportPeople',
  'setPropertyGuestRequestsEnabled',
  'setPropertyMinibarCheck',
  'setPropertyRoomTypes',
  'setPublicBookingLink',
  'setRetentionSettings',
  'setRoomDueOut',
  'setRoomService',
  'setRoomTags',
  'setRoomType',
  'setSampleSettings',
  'setSectorRoles',
  'setSharedDevicePinByPhone',
  'setSharedDeviceSettings',
  'setStaffStatus',
  'sharedDeviceSwitchIn',
  'sharedDeviceSwitchOut',
  'signLostFoundDisposal',
  'skipDue',
  'skipToken',
  'startBmwHandover',
  'startLostFoundClaim',
  'startNarcCount',
  'startRequest',
  'startRoomClean',
  'startSampleHandover',
  'startTeleSession',
  'submitBmwDay',
  'submitConMeasurement',
  'submitDpr',
  'submitNarcTally',
  'submitRecord',
  'submitSharedDeviceQueued',
  'submitTeleConsent',
  'submitTemplateVersion',
  'testStaysPmsEzeeConnection',
  'testStaysPmsHotelogixConnection',
  'unassignRoom',
  'unfreezeMembership',
  'unlinkGoalFromEngagement',
  'unlockOpsWageSheet',
  'updateAsset',
  'updateBookable',
  'updateBookingPlan',
  'updateComplianceItem',
  'updateConIssue',
  'updateConProject',
  'updateCoverageRule',
  'updateDutyRole',
  'updateEngagement',
  'updateHosPatient',
  'updateJobOrderStage',
  'updateJobSite',
  'updateParty',
  'updateSchedule',
  'updateShift',
  'updateStaysPmsConnection',
  'updateWorker',
  'upsertAllocation',
  'upsertConParty',
  'upsertCustomer',
  'upsertRequestKind',
  'verifyLostFoundClaim',
  'verifyRequest',
  'waiveDue',
  'waiveStrike',
  'withdrawConDrawing',
  'withdrawConIssue',
  'withdrawHosConsent',
  'withdrawLostFoundDisposal',
])

export const OPS_CALLABLE_FUNCTIONS = OPS_CALLABLE_HANDLERS
